import { createClient, SupabaseClient, RealtimeChannel } from '@supabase/supabase-js';
import { getSupabaseAccessToken } from './session';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || '';

// Every request carries the staff member's Supabase token from auth-exchange,
// so RLS sees auth.uid() = their profile. `supabase.auth` is unavailable in
// this mode by design — identity lives in ./session.ts.
export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  accessToken: getSupabaseAccessToken,
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Channel management
const channels: Map<string, RealtimeChannel> = new Map();

export function getConversationChannel(conversationId: string): RealtimeChannel {
  const existing = channels.get(conversationId);
  if (existing) return existing;

  const channel = supabase.channel(`conversation:${conversationId}`);
  channels.set(conversationId, channel);
  return channel;
}

export function removeConversationChannel(conversationId: string): void {
  const channel = channels.get(conversationId);
  if (channel) {
    supabase.removeChannel(channel);
    channels.delete(conversationId);
  }
}
